import React from 'react';
import './SapConsultingIntro.css';
import GRCIMG from '../../assets/images/GRC.png'; 

const SapConsultingIntro = () => {
  return (
    <section className="sap-consulting-intro-section">
      <div className="container">
        <div className="sap-consulting-intro-grid">
          <div className="sap-consulting-text-content">
            <h2 className="sap-consulting-title">Transform Your Business with Neuroverse AI's Premier SAP Consulting Services</h2>
            <p>
              Our SAP consulting services in the USA are designed to optimize your business processes and drive digital transformation. As the best SAP consultants for businesses, we offer tailored solutions to meet your specific needs. Partnering with top SAP consulting firms, we ensure the successful implementation and support of SAP systems. Our SAP implementation and support services provide end-to-end solutions, from initial planning to ongoing maintenance. We offer comprehensive SAP consulting and implementation services, guiding your organization through every step of the process.
            </p>
            <p>
              Adopting the right technology can make or break your success in today’s dynamic business environment. Neuroverse AI offers top SAP consulting services in the USA, empowering businesses to streamline operations, enhance productivity, and achieve scalable growth. With a team of highly skilled SAP experts, we provide customized solutions tailored to meet your organisation’s unique needs.
            </p>
          </div>
          <div className="sap-consulting-image-container">
            <img 
              src={GRCIMG} 
              alt="SAP Technology in Retail" 
              className="sap-consulting-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SapConsultingIntro;
